import { ConnectionDto, ConnectionName } from "@arelia-types/connection";
import { createContext } from "react";

export interface ConnectionsContextModel {
  connectionsDto: ConnectionDto[];
  viewConnections: ConnectionDto[];
  activeConnections: ConnectionName[];
  setActiveConnections: (connections: ConnectionName[]) => void;
}

const ConnectionsContext = createContext<ConnectionsContextModel>({
  connectionsDto: [],
  viewConnections: [],
  activeConnections: [],
  setActiveConnections: () => {}
});

export default ConnectionsContext;